let language = {
    SHIPPING_TABLE_THEAD_PRODUCT: "产品",
    SHIPPING_TABLE_THEAD_COUNTRY:"国家",
    SHIPPING_TABLE_THEAD_METHOD:"配送方式",
    SHIPPING_TABLE_THEAD_PRICE:"预计价格",
    SHIPPING_TABLE_THEAD_PRICE_TIP:"基于数量",
    SHIPPING_TABLE_THEAD_TIME:"运输时间",
    SHIPPING_TABLE_THEAD_UPDATE_QTY_BTN:"更新",
    SHIPPING_TABLE_TBODY_TIME:"{{from}} - {{to}}工作日"
}
export {language};